"use client"

import { CheckMark, CloseIcon, Data, Online, Presencial } from '@/components/Icons';
import { Atividades } from '@prisma/client';
import Link from 'next/link';
import React, { useState } from 'react'
import {
    confirmarPresencaAtividade
} from '@/components/Pages/Eventos/actions';


import dayjs from "dayjs"
import 'dayjs/locale/pt-br'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'
import { Button } from "@/components/ui/button";

dayjs.extend(timezone);
dayjs.extend(utc);
dayjs.tz.setDefault('America/Sao_Paulo');

export default function ButtonConfirmed({ atividade, participanteId, statusInscricao }: {
    atividade: Atividades,
    participanteId: string,
    statusInscricao: 'CONFIRMADO' | ""
}) {


    const isConfirmed = statusInscricao === 'CONFIRMADO';
    const [showModal, setShowModal] = useState(false);
    const handleModalToggle = () => {
        setShowModal(!showModal);
    };

    const handleConfirm = async () => {
        const response = await confirmarPresencaAtividade(atividade?.ATIV_IDEN, participanteId, atividade?.EVE_IDEN);
        if (response.status === 200) {
            alert(response.message)
            handleModalToggle()
        }

    }


    const todayDate = dayjs().locale('pt-br')
    const endDate = dayjs(atividade?.ATIV_DATA_FIM).add(3, 'hour').locale('pt-br')

    if (todayDate.isAfter(endDate)) {
        return (
            <Button variant="destructive" className="max-lg:fixed max-lg:bottom-10 max-lg:left-10 max-lg:right-10 max-lg:z-10 max-lg:shadow-xl ">Incrições encerradas</Button>
        )
    }


    return (
        <>
            {
                <Button onClick={handleModalToggle} variant="pucicon"
                    className="max-lg:fixed max-lg:bottom-10 max-lg:left-10 max-lg:right-10 max-lg:z-10 max-lg:shadow-xl "
                >
                    {isConfirmed ? <span>Inscrição Confirmada</span> : <span>Inscreva-se na atividade</span>}
                </Button>

            }

            {
                showModal && (
                    <div className="fixed bg-gray-700/40 w-full h-screen z-20 overflow-hidden  left-0 right-0 top-0 bottom-0">

                        <div className="fixed  top-1/2 transform -translate-y-1/2 left-0 right-0 z-50 p-4 overflow-hidden " onClick={handleModalToggle}>
                            <div onClick={e => e.stopPropagation()} className="relative w-full max-w-2xl max-h-full m-auto bg-white rounded-lg">
                                <div className="flex justify-end p-6">
                                    <button
                                        type="button"
                                        className=""
                                        onClick={handleModalToggle}
                                    >
                                        <CloseIcon className=' transition-all hover:opacity-70' />
                                    </button>
                                </div>
                                <div className="max-sm:px-6 px-20 py-2 mx-auto max-sm:pb-10 pb-20">
                                    <h3 className=' text-[26px] font-semibold text-puc-blue-secondary leading-7 max-sm:text-center'>{atividade?.ATIV_TITULO}</h3>

                                    <div className='mt-4 flex max-sm:flex-col items-center justify-between'>
                                        <div className='flex max-sm:gap-6 sm:gap-20'>


                                            <div className='flex gap-2 items-center text-base text-puc-blue-secondary font-medium'>
                                                <Data fill='#1D3C85' />
                                                <p> {dayjs(atividade?.ATIV_DATA_INICIO).utc().locale('pt-br').format('DD [de] MMM. HH:mm') + ' até ' + dayjs(atividade?.ATIV_DATA_FIM).utc().locale('pt-br').format('DD [de] MMM. HH:mm')}</p>
                                            </div>

                                            {
                                                atividade?.ATIV_MODALIDADE_INSCRICAO && (
                                                    <div className="flex gap-2 items-center text-puc-blue-secondary">
                                                        {atividade?.ATIV_MODALIDADE_INSCRICAO === 'PRESENCIAL' ? <Presencial fill="text-puc-blue-secondary" /> : <Online fill="text-puc-blue-secondary" />}
                                                        <p className="text-base font-medium text-puc-blue-secondary">
                                                            {atividade?.ATIV_MODALIDADE_INSCRICAO}
                                                        </p>
                                                    </div>
                                                )
                                            }
                                        </div>

                                    </div>
                                    {
                                        isConfirmed && (
                                            <div className="flex gap-2 items-center mt-3 text-base text-puc-green-primary font-medium">

                                                <CheckMark /> Inscrição confirmada
                                            </div>

                                        )
                                    }

                                    {
                                        isConfirmed && atividade?.ATIV_MODALIDADE_INSCRICAO === 'ONLINE' ? (
                                            <div className=' my-10 py-7 space-y-1 border-t-[2px] border-b-[2px] border-[#D6D6D6] text-lg text-puc-blue-secondary'>
                                                <p className=' font-light '>Link de acesso:</p>
                                                <Link href={atividade?.ATIV_URL_ACESSO ?? "#"} target='_blank' className=' font-medium underline line-clamp-1'>
                                                    Acessar o evento
                                                </Link>
                                            </div>
                                        ) : null
                                    }

                                    {
                                        !isConfirmed && (

                                            <Button
                                                onClick={handleConfirm}
                                                className="text-lg text-center font-bold rounded-full mx-auto py-3 w-full transition-all hover:opacity-70 mt-5 text-white bg-puc-green-primary">
                                                Confirmar Inscrição
                                            </Button>
                                        )
                                    }

                                    <div className="flex flex-col items-center gap-1 mt-3">
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" color="#000000" fill="none">
                                            <path d="M5.32171 9.6829C7.73539 5.41196 8.94222 3.27648 10.5983 2.72678C11.5093 2.42437 12.4907 2.42437 13.4017 2.72678C15.0578 3.27648 16.2646 5.41196 18.6783 9.6829C21.092 13.9538 22.2988 16.0893 21.9368 17.8293C21.7376 18.7866 21.2469 19.6548 20.535 20.3097C19.241 21.5 16.8274 21.5 12 21.5C7.17265 21.5 4.75897 21.5 3.46496 20.3097C2.75308 19.6548 2.26239 18.7866 2.06322 17.8293C1.70119 16.0893 2.90803 13.9538 5.32171 9.6829Z" stroke="currentColor" strokeWidth="1.5" />
                                            <path d="M12.2422 17V13C12.2422 12.5286 12.2422 12.2929 12.0957 12.1464C11.9493 12 11.7136 12 11.2422 12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                            <path d="M11.992 8.99997H12.001" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /> </svg>

                                        <p className="text-xs text-gray-600 text-center ">A inscrição inicial não confirma sua participação. Confirme seu comparecimento durante o evento, escaneando o QR Code e inserindo o código fornecido. </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            }
        </>
    )

}


